/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import DocumentStatusThree from '../../../components/DocumentStatusThree';
import { DownloadProviderImage } from '../../../reduxToolkit/Providers/providersApi';
import DeleteModal from '../../Modals/DeleteModal';
import UnlinkDeviceChangeModal from '../../Provider/Modal/UnlinkDeviceChangeModal';
import {
    CreateContractorDocValue,
    SetContractorDocValue,
} from '../../../reduxToolkit/Contractor/ContractorApi';
import DivContainerBody from '../../../components/DivContainerBody';
import EmployeeDetailsBodyApp from "./Functionality/EmployeeDetailsBodyApp";
import {TABLES} from "../../../Apis/Tables";
import {USER_TYPE_DOCUMENT} from "../../../enums/userTypeEnum";
import EmployeeCardGrid from "./SubComponents/EmployeeCardGrid";

const EmployeeDetailsBody = (props) => {
    const {  deleteEmployeeShow, setDeleteEmployeeShow, unlinkShow,  setUnlinkShow, showBtnDeleteDoc, disabled } = props;
    const {
        t,
        deleteDocShow,
        setDeleteDocShow,
        selectDocumentsForDelete,
        selectEmployeeForDelete,
        setSelectDocumentsForDelete,
        isAllChecked,
        setIsAllChecked,
        elementDetails,
        deletedFlag,
        setDeletedFlag,
        deleteSelectedDocuments,
        deleteSelectedElement
    } = EmployeeDetailsBodyApp(props);

    return (
        <>
            <DivContainerBody>
                <div className='row mt-5rem'>
                    <EmployeeCardGrid elementDetails={elementDetails}/>
                    <div className='col-8 mb-2'>
                        <div className='w-100 border-card h-100'>
                            <DocumentStatusThree
                                disabled={disabled}
                                dataTable={elementDetails?.documents}
                                userType={TABLES.CONTRACTORS}
                                setDocValue={SetContractorDocValue}
                                createDocValue={CreateContractorDocValue}
                                downloadImg={DownloadProviderImage}
                                optionDownload={USER_TYPE_DOCUMENT.CONTRACTOR_DOCUMENT}
                                isAllChecked={isAllChecked}
                                setIsAllChecked={setIsAllChecked}
                                selectDocumentsForDelete={selectDocumentsForDelete}
                                setSelectDocumentsForDelete={setSelectDocumentsForDelete}
                                showBtnDelete={showBtnDeleteDoc}
                                deleteShowModal={deleteDocShow}
                                setDeleteShowModal={setDeleteDocShow}
                                handleDelete={deleteSelectedDocuments}
                            />

                        </div>
                    </div>
                </div>
            </DivContainerBody>

            <DeleteModal
                title_modal={t('delete')}
                show={deleteEmployeeShow}
                onHide={() => setDeleteEmployeeShow(false)}
                element_modal={t('employees')}
                data={[selectEmployeeForDelete]}
                onClickFn={() => deleteSelectedElement(selectEmployeeForDelete)}
            />

            <UnlinkDeviceChangeModal
                show={unlinkShow}
                onHide={() => setUnlinkShow(false)}
                onConfirm={() => setDeletedFlag(deletedFlag + 1)}
                userId={elementDetails?.user?.id}
            />
        </>
    );
};

export default EmployeeDetailsBody;
